 import './App.css'; 
import MainDiv from './components/MainDiv';

function App() {
  return (
    <div className="App">
      <MainDiv /> 
    </div>
  );
}

export default App;
